import OnOffSwitch, {OnOffSwitchProp} from "./OnOffSwitch";


export default function YesNoSwitch(props:OnOffSwitchProp) {
    return <OnOffSwitch {...props} onString={"Yes"} offString={"No"}/>
}